export const style = (theme) => ({
  container: {
    padding: "2rem",
    marginBottom: "2rem",
  },
  divider: {
    margin: "1rem 0",
  },
  session: {
    fontSize: "20px",
  },
  containerSwitch: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  buttonContainer: {
    padding: "2rem 0rem 0rem",
  },
  button: {
    marginRight: "1rem",
  },
  customCell: {
    padding: "16px",
    color: "#263238",
    cursor: "pointer",
  },
  containerSwitch: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  selectedItem: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});
export const styleForm = (theme) => ({
  button: {
    marginLeft: "1rem",
  },
  containerBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  containerSwitch: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  form: {
    padding: "2rem",
    marginBottom: "2rem",
  },
});
export const styleInputImageForm = (theme) => ({
  container: {
    display: "flex",
    flexFlow: "row",
    flexWrap: "wrap",
  },
  listItem: {
    position: "relative",
    width: "150px",
    cursor: "pointer",
    height: "150px",
    margin: "8px 16px 8px 0",
    boxShadow:
      "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    // width : '100%',
    //  height: "100%",
    //  boxShadow:
    //    "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    //  position: "relative",
  },
  inputImage: {
    display: "none",
  },
  buttonIcon: {
    width: 64,
    height: 64,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 60,
    color: "rgb(204, 204, 204)",
  },
  buttonHover: {
    width: 36,
    height: 36,
    margin: "0px 5px",
  },
});
export const styleMultiLevelCategoryList = (theme) => ({
  list: {
    overflowY: "auto",
    maxHeight: "20vh",
  },
  custom: {
    paddingTop: 0,
  },
  selectedItem: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});
